export function interpolateVariables(
  template: string,
  variables: Record<string, string>,
  speechFormats?: Record<string, string>,
): string {
  return template.replace(/\{\{(\w+)\}\}/g, (match, varName) => {
    const value = variables[varName];
    if (value === undefined) return match;
    const format = speechFormats?.[varName];
    return format ? `\x01${format}(${value})\x01` : value;
  });
}

export function resolveMessage(
  message: string | Record<string, string>,
  languageCode?: string,
  defaultLanguage?: string,
): string {
  if (typeof message === 'string') return message;

  if (languageCode && message[languageCode]) return message[languageCode];
  if (defaultLanguage && message[defaultLanguage] !== undefined) return message[defaultLanguage];
  return '';
}

export type Rephrases = Record<string, string[]>;

export function pruneInactiveLanguageEntries<V>(
  value: Record<string, V>,
  activeLanguageCodes: ReadonlySet<string>,
): Record<string, V> {
  const filtered: Record<string, V> = {};
  for (const [key, val] of Object.entries(value)) {
    if (key === '_default' || activeLanguageCodes.has(key)) {
      filtered[key] = val;
    }
  }
  return filtered;
}

export function resolveMessageWithRephrases(
  message: string | Record<string, string>,
  rephrases: Rephrases | undefined,
  visitCount: number,
  languageCode?: string,
  defaultLanguage?: string,
): string {
  const original = resolveMessage(message, languageCode, defaultLanguage);
  if (!rephrases || visitCount === 0) return original;

  const langKey = typeof message === 'string' ? '_default' : (languageCode ?? defaultLanguage ?? '_default');
  const options = rephrases[langKey];
  if (!options || options.length === 0) return original;

  return options[(visitCount - 1) % options.length] ?? original;
}
